import { render, staticRenderFns } from "./InstalledApps.vue?vue&type=template&id=e3526fba&"
import script from "./InstalledApps.vue?vue&type=script&lang=js&"
export * from "./InstalledApps.vue?vue&type=script&lang=js&"
import style0 from "./InstalledApps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports